// extracted by mini-css-extract-plugin
module.exports =  {"wrapper":"_93444fe79c--wrapper--iFgUa"};